import React from 'react';
import capitalize from 'lodash/capitalize';
import { Field } from 'formik';

import ProductSelect from './ProductSelect';
import StatusSelect from './StatusSelect';
import DatePicker from '../../datePicker/DatePicker';
import text from '../../../text';
import AssetIcon from '../../icon/common/AssetIcon';
import { ASSET_ICON_MAP, OTHER_PRODUCTS } from '../../../constants/product';
import { get } from 'lodash';
import { DETAILED_STATUS } from '../../../constants/job';
import { formatDate, getNowDate } from '../../../utilities/date';
import AssetIconV2 from '../../icon/common/AssetIconV2';
import { isDerivedDataType } from '@larki/mp/lib/dataType';
import classNames from 'classnames';
import { getProductLabel } from '../../../utilities/activity';

const ProductRow = (props) => {
  const { initialProducts, products, product, name } = props;
  const today = new Date();
  const matchedOther =
    OTHER_PRODUCTS.find(
      ({ label }) =>
        typeof product.productKey === 'string' &&
        product.productKey.includes(label)
    ) || null;
  const assetIcon =
    ASSET_ICON_MAP[product.productKey] ??
    (matchedOther ? matchedOther.icon : null);
  const isDerived = isDerivedDataType(product.productKey.toLowerCase());

  return (
    <tr className='ProductRow'>
      <td className='productCell'>
        <AssetIconV2
          {...(assetIcon && !matchedOther
            ? {
                icon:
                  isDerived || product.productKey.toLowerCase() === 'unknown'
                    ? `${product.productKey.toLowerCase()}_white`
                    : product.productKey.toLowerCase(),
              }
            : {
                icon: assetIcon,
              })}
          classNames={classNames('mr-2', assetIcon, {
            'inverted rounded-corners': !matchedOther,
          })}
          defaultIcon='question-mark'
        />

        <Field name={`${name}.productKey`}>
          {({ field, form: { setFieldValue } }) => {
            const existingProduct = initialProducts.find(
              (item) => item.productKey === field.value
            );
            return existingProduct ? (
              <span className='productLabel'>
                {getProductLabel(field.value)}
              </span>
            ) : (
              <ProductSelect
                existingProducts={products}
                product={field.value}
                placeholder={text('addNewProduct')}
                onChange={(option) =>
                  setFieldValue(field.name, option.productKey)
                }
              />
            );
          }}
        </Field>
      </td>
      <td className='statusCell'>
        <Field name={`${name}.status`}>
          {({ field, form: { setFieldValue } }) => (
            <StatusSelect
              status={field.value}
              placeholder={text('selectStatus')}
              onChange={(option) =>
                setFieldValue(field.name, capitalize(option.status))
              }
            />
          )}
        </Field>
      </td>
      <td className='etaCell'>
        <Field name={`${name}.expectedAt`}>
          {({ field, form: { setFieldValue, values } }) =>
            product.status === DETAILED_STATUS.COMPLETED ? (
              text('completedByDate', {
                completedDate: formatDate(product?.completedAt || getNowDate()),
              })
            ) : (
              <DatePicker
                placeholder={text('selectDate')}
                minDate={today}
                onChange={(date) =>
                  setFieldValue(field.name, date?.toISOString())
                }
                value={
                  field.value &&
                  ![DETAILED_STATUS.COMPLETED].includes(
                    get(values, `${name}.status`)
                  )
                    ? new Date(field.value)
                    : null
                }
              />
            )
          }
        </Field>
      </td>
    </tr>
  );
};

export default ProductRow;
